<template>
  <div :class="$style.field">
    <label :for="id">
      {{ entity.label }}
      <i v-if="required">*</i>
    </label>
    <flat-pickr
      :id="id"
      :disabled="readonly"
      v-model="value"
      :placeholder="entity.description"
      :name="name"
      :required="required"
      :config="config"
    ></flat-pickr>
    <p v-show="error && showError">{{ error }}</p>
  </div>
</template>

<script>
import moment from "moment";
import FlatPickr from "vue-flatpickr-component";
import Field from "./field";

export default {
  mixins: [Field],
  components: { FlatPickr },
  data() {
    return {
      config: {
        noCalendar: true,
        enableTime: true,
        dateFormat: "H:i",
        time_24hr: true,
      },
    };
  },
  mounted() {
    const el = this.$el.querySelector(".form-control:not([type=hidden])");

    if (el) {
      el.classList.remove("form-control");
    }
  },
  methods: {
    typecast(timeLocal) {
      if (!timeLocal) {
        return null;
      }

      const [hour, minute] = timeLocal.split(":");
      const date = moment();

      date.hour(hour).minute(minute).utc();

      const timeUTC = date.format("HH:mm");
      return timeUTC;
    },
  },
};
</script>

<style lang="stylus" src="./datetime-field.styl"></style>
<style module lang="less" src="./field.less"></style>



// WEBPACK FOOTER //
// time-field.vue?05d1128c